import { VitalSignCareElementName } from "./Models/CareElements/VitalSignCareElementName";

const FlowsheetConstants = Object.freeze({
    DiabetesBasic: Object.freeze({
        CareComponentName: "DiabetesBasicCareComponent",
        GlucoseMonitoring: Object.freeze({
            SubSectionName: "GlucoseMonitoring",
            SelfMonitoringBloodGlucoseCareElementName: "SelfMonitoringBloodGlucose",
            NumberOfHypoglycemicEpisodesCareElementName: "NumberOfHypoglycemicEpisodes",
            FastingGlucoseMonitorLabResultComparisonCalibratedCareElementName: "FastingGlucoseMonitorLabResultComparisonCalibrated"
        }),
        Complications: Object.freeze({
            SubSectionName: "Complications",
            ElectrocardiogramCareElementName: "Electrocardiogram",
            AcetylsalicylicAcidUseCareElementName: "AcetylsalicylicAcidUse",
            PsychosocialScreeningCareElementName: "PsychosocialScreening"
        })
    }),
    ChronicObstructivePulmonaryDiseaseBasic: Object.freeze({
        CareComponentName: "ChronicObstructivePulmonaryDiseaseBasicCareComponent",
        AssessmentAndMonitoring: Object.freeze({
            SubSectionName: "AssessmentAndMonitoring",
            ChronicObstructivePulmonaryDiseaseClassification: "ChronicObstructivePulmonaryDiseaseClassification",
            Exacerbations: "NumberOfExacerbations",
            LastExacerbationDate: "LastExacerbationDate",
            SpirometryTest: "SpirometryTest",
            NeedForSupplementalOxygen: "NeedForSupplementalOxygen",
            NeedForNocturnalVentilation: "NeedForNocturnalVentilation"
        }),
        DiagnosticsTests: Object.freeze({
            SubSectionName: "DiagnosticsTests",
            ArterialBloodGasTest: "ArterialBloodGasTest"
        }),
        TreatmentAndManagement: Object.freeze({
            SubSectionName: "TreatmentAndManagement",
            MedicationTopicReviewed: "MedicationTopicReviewed",
            PathophysiologyPrognosisTreatmentTopicReviewed: "PathophysiologyPrognosisTreatmentTopicReviewed",
            ExacerbationPlan: "ExacerbationPlan",
            ExacerbationPlanProvidedOptionName: "ExacerbationPlanProvidedOption",
            ExacerbationPlanRevisedOptionName: "ExacerbationPlanRevisedOption",
            ExacerbationPlanReviewedOptionName: "ExacerbationPlanReviewedOption"
        }),
        PatientEducation: Object.freeze({
            SubSectionName: "PatientEducation",
            SmokingCessationTopicReviewed: "SmokingCessationTopicReviewed",
            SmokingCessationProgramTopicReviewed: "SmokingCessationProgramTopicReviewed",
            PulmonaryRehabilitationTopicReviewed: "PulmonaryRehabilitationTopicReviewed",
            ProvidePatientEducationTopicReviewed: "ProvidePatientEducationTopicReviewed",
            SpecialistReferralTopicReviewed: "SpecialistReferralTopicReviewed"
        })
    }),
    LabResults: Object.freeze({
        CareComponentName: "LabResultsCareComponent",
        HBA1cCareElementName: "HbA1C",
        HDLCareElementName: "HDL",
        LDLCareElementName: "LDL",
        CHOLHDLCareElementName: "CHOLHDL",
        TGCareElementName: "TG",
        AlbuminCreatinineCareElementName: "AlbuminCreatinine",
        FPGCareElementName: "FPG",
        GlucoseCareElementName: "Glucose2h",
        EGFRCareElementName: "EGFR",
        AlbuminCareElementName: "AlbuminUrine",
        NaCareElementName: "Na",
        KCareElementName: "K",
        CreatinineCareElementName: "Creatinine",
        O2SaturationCareElementName: "O2Saturation"
    }),
    VitalSigns: Object.freeze({
        CareComponentName: "VitalSignsCareComponent",
        BloodPressureCareElementName: VitalSignCareElementName.BloodPressure,
        BloodPressureSystolicCareElementName: VitalSignCareElementName.BloodPressureSystolic,
        BloodPressureDiastolicCareElementName: VitalSignCareElementName.BloodPressureDiastolic,
        BodyMassIndexCareElementName: VitalSignCareElementName.BodyMassIndex,
        WaistCircumferenceCareElementName: VitalSignCareElementName.WaistCircumference,
        HeightCareElementName: VitalSignCareElementName.Height,
        WeightCareElementName: VitalSignCareElementName.Weight,
        HeartRateCareElementName: VitalSignCareElementName.HeartRate
    }),
    CounselingAndEducation: Object.freeze({
        CareComponentName: "CounselingAndEducationCareComponent",
        SmokingCessationCareElementName: "SmokingCessationTopic",
        NutritionCareElementName: "NutritionTopic",
        ExerciseCareElementName: "ExerciseTopic",
        ImmunizationCareElementName: "ImmunizationsTopic",
        OtherCareElementName: "OtherTopic",
        NutritionLipidsCareElementName: "NutritionLipidsTopic",
        NutritionDiabetesCareElementName: "NutritionDiabetesTopic",
        DiabetesCareElementName: "DiabetesTopic"
    }),
    Screening: Object.freeze({
        CareComponentName: "ScreeningCareComponent",
        DilatedEyeCareElementName: "DilatedEye",
        FootCareElementName: "Foot",
        NeurologicalCareElementName: "Neurological"
    }),
    Immunizations: Object.freeze({
        CareComponentName: "ImmunizationsCareComponent",
        InfluenzaCareElementName: "Influenza",
        PneumococcalCareElementName: "Pneumococcal"
    }),
    RiskFactors: Object.freeze({
        CareComponentName: "RiskFactorsCareComponent",
        SmokingStatusCareElementName: "SmokingStatus",
        AlcoholUseCareElementName: "AlcoholUse",
        ErectileFunctionCareElementName: "ErectileFunction"
    }),
    Spirometry: Object.freeze({
        CareComponentName: "SpirometryCareComponent",
        PredictedCareElemenSuffix: "Predicted",
        ForcedExpiratoryVolumeInOneSecondCareElementName: "ForcedExpiratoryVolumeInOneSecond",
        ForcedVitalCapacityCareElementName: "ForcedVitalCapacity",
        ForcedExpiratoryVolumeInOneSecondComparedToPredictedNormalValueCareElementName: "ForcedExpiratoryVolumeInOneSecondComparedToPredictedNormalValue",
        ForcedVitalCapacityRatioCareElementName: "ForcedVitalCapacityRatio",
        ForcedExpiratoryVolumeInOneSecondForcedVitalCapacityRatioCareElementName: "ForcedExpiratoryVolumeInOneSecondForcedVitalCapacityRatio",
        PersonalPeakExpiratoryFlowCareElementName: "PersonalPeakExpiratoryFlow",
        ForcedExpiratoryVolumeInOneSecondRatioCareElementName: "ForcedExpiratoryVolumeInOneSecondRatio"
    }),
    AsthmaBasic: Object.freeze({
        CareComponentName: "AsthmaBasicCareComponent",
        SymptomsOfAsthma: Object.freeze({
            SubSectionName: "SymptomsOfAsthma",
            DyspneaCareElementName: "Dyspnea",
            CoughCareElementName: "Cough",
            WheezeCareElementName: "Wheeze",
            ChestTightnessCareElementName: "ChestTightness",
            NightTimeSymptomsCareElementName: "NightTimeSymptoms"
        }),
        Exacerbations: Object.freeze({
            SubSectionName: "Exacerbations",
            ExacerbationsCareElementName: "NumberOfExacerbations"
        }),
        Monitoring: Object.freeze({
            SubSectionName: "Monitoring",
            SpirometryTestCareElementName: "SpirometryTest",
            SchoolWorkAbsenceCareElementName: "SchoolWorkAbsence",
            NumberOfSchoolWorkAbsenceCareElementName: "NumberOfSchoolWorkAbsence",
            LimitsPhysicalActivityCareElementName: "LimitsPhysicalActivity",
            RelieverUseCareElementName: "RelieverUse",
            MedicationReviewedCareElementName: "MedicationReviewed",
            SmokingCessationDiscussedCareElementName: "SmokingCessationDiscussed",
            OptimalDeviceTechniqueReviewCareElementName: "OptimalDeviceTechniqueReview",
            EducationReferralCareElementName: "EducationReferral",
            SpecialistReferralCareElementName: "SpecialistReferral",
            EnvironmentalControlCareElementName: "EnvironmentalControl",
            CopingStrategiesCareElementName: "CopingStrategies",
            TriggerAvoidanceCareElementName: "TriggerAvoidance",
            DefinitionReviewCareElementName: "DefinitionReview",
            ActionPlanCareElementName: "ActionPlan",
            ActionPlanProvidedOptionName: "ActionPlanProvidedOption",
            ActionPlanRevisedOptionName: "ActionPlanRevisedOption",
            ActionPlanReviewedOptionName: "ActionPlanReviewedOption"
        })
    }),
    HeartFailureBasic: Object.freeze({
        CareComponentName: "HeartFailureBasicCareComponent",
        PhysicalExamination: Object.freeze({
            SubSectionName: "PhysicalExamination",
            PhysicalExaminationNotesCareElementName: "PhysicalExaminationNotes",
            FatiguePerWeekCareElementName: "FatiguePerWeek",
            DizzinessOrSyncopePerWeekCareElementName: "DizzinessOrSyncopePerWeek",
            DyspneaOnExertionPerWeekCareElementName: "DyspneaOnExertionPerWeek",
            DyspneaAtRestPerWeekCareElementName: "DyspneaAtRestPerWeek",
            OrthopneaPerWeekCareElementName: "OrthopneaPerWeek",
            ParoxysmalNocturnalDyspneaPerWeekCareElementName: "ParoxysmalNocturnalDyspneaPerWeek",
            JugularVenousPressureElevationCareElementName: "JugularVenousPressureElevation",
            SignsOfPharmacologicalIntoleranceCareElementName: "SignsOfPharmacologicalIntolerance",
            NewYorkHeartAssociationFunctionalCapacityClassificationCareElementName: "NewYorkHeartAssociationFunctionalCapacityClassification",
            MedicationReviewCareElementName: "MedicationReview",
            PittingEdemaCareElementName: "PittingEdema",
            LungCracklesCareElementName: "LungCrackles",
            WheezingCareElementName: "Wheezing",
            NewYorkHeartAssociationClassIOptionName: "ClassI",
            NewYorkHeartAssociationClassIIOptionName: "ClassII",
            NewYorkHeartAssociationClassIIIOptionName: "ClassIII",
            NewYorkHeartAssociationClassIVOptionName: "ClassIV"
        }),
        PatientSelfManagement: Object.freeze({
            SubSectionName: "PatientSelfManagement",
            NumberOfERVisitsSinceLastAssessmentCareElementName: "NumberOfERVisitsSinceLastAssessment",
            EducationSelfManagementTrainingCareElementName: "EducationSelfManagementTraining",
            TargetModifiableRiskFactorsForHeartFailureAndCoronaryArteryDiseaseCareElementName: "TargetModifiableRiskFactorsForHeartFailureAndCoronaryArteryDisease",
            PatientMedicationUseOptionName: "PatientMedicationUse",
            SaltFluidVigilanceOptionName: "SaltFluidVigilance",
            DailyWeightMonitoringOptionName: "DailyWeightMonitoring",
            ExerciseActivityOptionName: "ExerciseActivity",
            HypertensionOptionName: "Hypertension",
            DiabetesOptionName: "Diabetes",
            HyperlipidemiaOptionName: "Hyperlipidemia",
            SmokingOptionName: "Smoking",
            OverweightObesityOptionName: "OverweightObesity"
        }),
        PharmacologicManagementFirstLine: Object.freeze({
            SubSectionName: "PharmacologicManagementFirstLine",
            AngiotensinConvertingEnzymeInhibitorCareElementName: "AngiotensinConvertingEnzymeInhibitor",
            BetaBlockerCareElementName: "BetaBlocker",
            AngiotensinReceptorBlockerIfAngiotensinConvertingEnzymeInhibitorIntolerantCareElementName: "AngiotensinReceptorBlockerIfAngiotensinConvertingEnzymeInhibitorIntolerant"
        }),
        PharmacologicManagementSymptomRelief: Object.freeze({
            SubSectionName: "PharmacologicManagementSymptomRelief",
            LoopDiureticMinimumEffectiveDoseCareElementName: "LoopDiureticMinimumEffectiveDose",
            SpironolactoneDoseCareElementName: "SpironolactoneClass3HeartFailure",
            DigoxinDoseCareElementName: "Digoxin"
        }),
        PharmacologicManagementPreventative: Object.freeze({
            SubSectionName: "PharmacologicManagementPreventative",
            ConsiderAcetylsalicylicAcidCareElementName: "ConsiderAcetylsalicylicAcid",
            AnticoagulantTherapyCareElementName: "AnticoagulantTherapy",
            NotesCareElementName: "PharmacologicManagementNotes"
        })
    }),
    Medication: Object.freeze({
        CareComponentName: "MedicationCareComponent"
    }),
    SelfManagementPlan: Object.freeze({
        CareComponentName: "SelfManagementPlanCareComponent",
        CollaborativeSelfManagementGoalsCareElementName: "CollaborativeSelfManagementGoals",
        SelfManagementChallengesCareElementName: "SelfManagementChallenges"
    }),
    HypertensionBasic: Object.freeze({
        CareComponentName: "HypertensionBasicCareComponent",
        TenYearCoronaryArteryDiseaseRiskCareElementName: "TenYearCoronaryArteryDiseaseRisk",
        MedicationReviewedCareElementName: "MedicationReviewed",
        ExerciseReviewedCareElementName: "ExerciseReviewed",
        SaltIntakeReviewedCareElementName: "SaltIntakeReviewed"
    }),
    ErrorCodes: Object.freeze({
        SnapshotGenerationError: "Flowsheet_SnapshotGenerationError"
    })
});

type CareComponentName =
    | typeof FlowsheetConstants.LabResults.CareComponentName
    | typeof FlowsheetConstants.VitalSigns.CareComponentName
    | typeof FlowsheetConstants.CounselingAndEducation.CareComponentName
    | typeof FlowsheetConstants.Screening.CareComponentName
    | typeof FlowsheetConstants.Immunizations.CareComponentName
    | typeof FlowsheetConstants.RiskFactors.CareComponentName
    | typeof FlowsheetConstants.Spirometry.CareComponentName
    | typeof FlowsheetConstants.HeartFailureBasic.CareComponentName
    | typeof FlowsheetConstants.Medication.CareComponentName
    | typeof FlowsheetConstants.SelfManagementPlan.CareComponentName
    | typeof FlowsheetConstants.HypertensionBasic.CareComponentName;

export {
    CareComponentName,
    FlowsheetConstants
};
